<template>
  <div class="animated fadeIn">
    <div class="row pb-2">
      <div class="col-6">
        <h3>My Account</h3>
      </div>
      <div class="col-6 text-right" />
    </div>
    <section class="card">
      <!-- The modal -->
      <b-form @submit="SaveItem" autocomplete="off">
        <div class="card-body">
          <b-form-group label="Email:">
            <b-form-input
              v-model="itemChange.email"
              :disabled="true"
              required
            />
          </b-form-group>
          <b-form-group label="Timezone:">
            <b-v-select
              v-model="itemChange.timezone"
              :options="timezonesList"
            />
          </b-form-group>
          <b-row>
            <b-form-group class="col-12 col-md-6" label="First Name:">
              <b-form-input v-model="itemChange.firstName" required />
            </b-form-group>
            <b-form-group class="col-12 col-md-6" label="Last Name:">
              <b-form-input v-model="itemChange.lastName" required />
            </b-form-group>

            <b-form-group class="col-6" label="">
              <b-form-checkbox
                v-model="itemChange.enableTicketEmailNotifications"
                name="check-button"
                switch
              >
                Enable Ticket Email Notifications
              </b-form-checkbox>
              <!-- <b-form-checkbox
                v-model="itemChange.enableEmailNotifications"
                name="check-button"
                switch
              >
                Enable POs/WTs Email Notifications
              </b-form-checkbox> -->
              <!-- <b-form-checkbox
                v-model="itemChange.enableSMSNotifications"
                name="check-button"
                switch
              >
                Enable POs/WTs SMS Notifications (for POs/WTs and more)
              </b-form-checkbox> -->
            </b-form-group>

            <b-form-group class="col-12 col-md-6" label="Phone Number:">
              <b-form-input
                name="phoneNumber"
                v-model="itemChange.phoneNumber"
              />
            </b-form-group>
            <div class="col-12 mt-3">
              <h4>Change Password:</h4>
            </div>
            <b-form-group class="col-12 col-md-6" label="New Password:">
              <b-form-input
                type="password"
                autocomplete="off"
                v-model="itemChange.password"
              />
            </b-form-group>
            <b-form-group class="col-12 col-md-6" label="Confirm New Password:">
              <b-form-input
                type="password"
                autocomplete="off"
                v-model="itemChange.confirmPassword"
              />
            </b-form-group>
          </b-row>
        </div>
        <div class="card-footer">
          <div class="w-100 clearfix">
            <b-button
              type="submit"
              variant="primary"
              size="mr-2 float-right"
              @click.prevent="SaveItem()"
            >
              Save User
            </b-button>
          </div>
        </div>
      </b-form>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Users',
  components: {},
  data() {
    return {
      timezonesList: [
        { value: -11, text: '(GMT -11:00) Midway Island' },
        { value: -10, text: '(GMT -10:00) Hawaii' },
        { value: -9, text: '(GMT -09:00) Alaska' },
        { value: -8, text: '(GMT -8:00) Pacific Time (US & Canada)' },
        { value: -7, text: '(GMT -7:00) Arizona' },
        { value: -6, text: '(GMT -6:00) Central Time (US & Canada)' },
        { value: -5, text: '(GMT -5:00) Eastern Time (US & Canada)' },
        {
          value: -4,
          text: '(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz'
        },
        { value: -3, text: '(GMT -3:00) Brazil, Buenos Aires, Georgetown' },
        { value: -2, text: '(GMT -2:00) Mid-Atlantic' },
        { value: -1, text: '(GMT -1:00 hour) Azores, Cape Verde Islands' },
        {
          value: 0,
          text: '(GMT/UTC) Western Europe Time, London, Lisbon, Casablanca'
        },
        {
          value: 1,
          text: '(GMT +1:00 hour) Brussels, Copenhagen, Madrid, Paris'
        },
        { value: 2, text: '(GMT +2:00) Kaliningrad, South Africa' },
        {
          value: 3,
          text: '(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg'
        },
        { value: 4, text: '(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi' },
        {
          value: 5,
          text: '(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent'
        },
        { value: 6, text: '(GMT +6:00) Almaty, Dhaka, Colombo' },
        { value: 7, text: '(GMT +7:00) Bangkok, Hanoi, Jakarta' },
        { value: 8, text: '(GMT +8:00) Beijing, Perth, Singapore, Hong Kong' },
        { value: 9, text: '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk' },
        {
          value: 10,
          text: '(GMT +10:00) Eastern Australia, Guam, Vladivostok'
        },
        {
          value: 11,
          text: '(GMT +11:00) Magadan, Solomon Islands, New Caledonia'
        },
        {
          value: 12,
          text: '(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka'
        }
      ],
      itemChange: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        newPassword: ''
      }
    };
  },
  mounted() {
    this.loadUser();
  },
  computed: {
    ...mapGetters('account', ['getUserData', 'isLoggedIn'])
  },
  methods: {
    loadUser() {
      let userId = this.getUserData.id;
      this.$http
        .get('/api/myinfo')
        .then(resp => {
          this.itemChange = resp.data;
        })
        .catch(err => {});
    },
    SaveChangedItem(user) {
      this.$http
        .post('/api/edit-account', user)
        .then(resp => {
          this.$swal('Changes Saved!', 'Account Changes Saved.', 'success');
        })
        .catch(err => {});
    },
    SaveItem() {
      this.SaveChangedItem(this.itemChange);
    }
  }
};
</script>
